// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");

function join(xs, delimiter) {
  var reduce = function (xs, delimiter) {
    return Belt_List.reduce(xs, /* tuple */[
                "",
                ""
              ], (function (param, s) {
                  return /* tuple */[
                          param[0] + (param[1] + s),
                          delimiter
                        ];
                }));
  };
  return reduce(xs, delimiter)[0];
}

function joinLines(__x) {
  return join(__x, "\n");
}

function indent(str, n) {
  return str.replace(/^/gm, " ".repeat(n));
}

function reverse(str) {
  return join(Belt_List.fromArray(Belt_Array.reverse(str.split(""))), "");
}

exports.join = join;
exports.joinLines = joinLines;
exports.indent = indent;
exports.reverse = reverse;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../belt-holes/src/BeltHoles_String.bs.js
// module id = 1475
// module chunks = 0